import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Campus1 from "../assets/campas.jpg";
import library from "../assets/library.jpg";
import classroom from "../assets/classroom.jpg";
import office from "../assets/office.jpg";
import sciencelab from "../assets/sciencelab.jpg";
const Gallery = () => {
  // Replace these with your actual image paths from src/assets
  const schoolPhotos = [
    {
      id: 1,
      src: Campus1,
      title: "Modern Campus",
    },
    {
      id: 2,
      src: sciencelab,
      title: "Science Lab",
    },
    {
      id: 3,
      src: library,
      title: "Library",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1544531585-9847b68c8c86",
      title: "Sports Day",
    },
    {
      id: 5,
      src: classroom,
      title: "Classroom",
    },
    {
      id: 6,
      src: office,
      title: "Office",
    },
  ];
  const sectionStyle = {
    backgroundColor: "#f2faf5", // Matching the Hero Light Green
    padding: "80px 0",
  };
  return (
    <section id="gallery" style={sectionStyle}>
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Our School Life & Campus</h2>
          <p className="text-muted">
            A glimpse into the daily environment at Viriya International School
          </p>
        </div>

        <Row className="g-4">
          {schoolPhotos.map((photo) => (
            <Col key={photo.id} xs={12} sm={6} lg={4}>
              <Card className="border-0 shadow-sm overflow-hidden h-100 gallery-card">
                <div className="img-container">
                  <Card.Img
                    variant="top"
                    src={photo.src}
                    alt={photo.title}
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                  <div className="gallery-overlay">
                    <span className="text-white fw-bold">{photo.title}</span>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;
